<template>
<div >
              <Dialogs header="Organization"  position="center" :visible.sync="value"
           :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">

          <form >
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12">
               <label for="accountType" style="color:#3c8dbc">Organization info:</label>
             </div>
             <div class="p-field p-col-12 p-md-4">
               <label for="name">Name</label>
               <InputText id="name" v-model.trim="name"/>
             </div>
             <div class="p-field p-col-12 p-md-4">
               <label for="shortName" >Short Name</label>
              <InputText v-model.trim="shortName" id="shortName"/>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="contactPerson">Contact Person</label>
              <InputText
                v-model.trim="contactPerson" id="contactPerson"/>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="contactNum" >Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="contactNumber" id="contactNum"/>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="tel" >Tel-phone</label>
                <InputText @keypress="isNumber($event)" v-model.trim="telcontact" id="tel"/>
              </div>
              <div class="p-field p-col-12 p-md-4">
                 <label for="email">Email</label>
                 <InputText v-model.trim="email" id="email"/>
               </div>
               <div class="p-field p-col-12 p-md-4">
                 <label for="address" >Address</label>
                 <InputText v-model.trim="address" id="address"/>
               </div>
               <div class="p-field p-col-12 p-md-4">
                 <label >Organisaction Type</label>
                 <select class=" form-control" v-model="taxType">
                   <option selected disabled value="">Select Type</option>
                   <option  v-for="(vat,ind) in organisaction_type" :key="ind">{{vat.taxType}}</option>
                 </select>
               </div>

               <div class="p-field p-col-12 p-md-4">
                <label for="panNo">Pan/Vat No</label>
                <InputText @keypress="isNumber($event)" v-model.number="panNo" id="panNo"/>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label >Date Type</label>
                <select class="form-control " v-model="isEnglishDate">
                  <option selected disabled value="">Select Date</option>
                  <option  v-for="(date,ind) in date_list" :key="ind">{{date.isEnglishDate}}</option>
                </select>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="exclude">Ask Bill Print After Sales</label>
                <Checkbox id="exclude" v-model="printBillRealTime" :binary="true" />
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="address">Website</label>
                <InputText v-model.trim="website" id="address"/>
              </div>
                  <div class="form-group col-md-4">
              <label for="imageUpload"  class="col-sm-3 col-form-label">Image </label>
              <div class="col-md-4" >
                <Button @click.prevent="showItemUpload" class="btn btn-primary">Upload Image</Button>
              </div>
              <div class="col-md-4" v-if="this.imageList.length > 0">
                <Button  @click.prevent="viewImage"  class="btn btn-primary">View Image</Button>
              </div>

              <!-- Image Upload Dialog -->
              <Dialogs header="Item Image Upload" :modal="true" :visible.sync="showItemUploadDialog" :style="{width:'50vw'}" :closable="false">
                <input type="file" id="files" style="margin-bottom: 2em;" class="hidden" @change="onFileSelect"/>
                <label for="files" style="margin-left: 2em;">Choose Image</label>
                <Carousel :value="url" :numVisible="2" :numScroll="2">
                    <template #item="slotProps">
                        <div class="product-item">
                            <div class="product-item-content">
                                <div class="p-mb-3">
                                    <img  :src="slotProps.data" style="height:250px;width:250px" class="product-image" />
                                </div>
                                <div>
                                    <div class="car-buttons p-mt-5">
                                        <Button class="btn btn-danger" @click.prevent="removeImage(slotProps.data,slotProps)"><i class="fa fa-trash" aria-hidden="true"></i></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </Carousel>
                <template #footer>
                  <!-- <Button class="btn btn-info" type="cancel" @click.prevent="closeImageUpload">Back</Button> -->
                  <Button class="p-button-raised p-button-raised" @click.prevent="closeImageUpload" label="Back"/>
                  <!-- <Button class="btn btn-danger" type="cancel" @click.prevent="cancelImageUpload">Cancel</Button> -->
                  <Button class="p-button-raised p-button-danger" @click.prevent="cancelImageUpload" label="Cancel"/>
                </template>
              </Dialogs>
              <!-- Image Upload Dialog -->

              <Dialogs header="View Image " :modal="true"
                :visible.sync="openImageViewer" :style="{width: '50vw'}">
                <div>
                  <div class="card">
                  <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                      <template #item="slotProps">
                          <div class="product-item">
                              <div class="product-item-content">
                                  <div class="p-mb-3">
                                      <img  :src="slotProps.data.name"  class="product-image" />
                                  </div>
                                  <div>
                        <div >
                          <Button class="p-button-raised  p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div>
                      </div>
                              </div>
                          </div>
                      </template>
                  </Carousel>
                </div>
                </div>
              </Dialogs>

             
            </div>

            <div class="p-field p-col-12 p-md-12">
            <div class="p-grid">
              <div class="p-col-12 p-md-4">
                <label for="address">POS Remarks</label>
                <Textarea v-model="orgRemarks" rows="5" cols="30" />
              </div>
              <div class="p-col-12 p-md-4" style="align-self: flex-start;">
                <label for="loginAllowedFrom">Login Allowed From</label>
                <Calendar
                  id="loginAllowedFrom"
                  v-model="loginAllowedFrom"
                  :timeOnly="true"
                  :hourFormat="'24'"
                  :showIcon="true"
                  :stepMinute="5"
                  placeholder="Select Start Time"
                />
              </div>
              <div class="p-col-12 p-md-4" style="align-self: flex-start;">
                <label for="loginAllowedTo">Login Allowed To</label>
                <Calendar
                  id="loginAllowedTo"
                  v-model="loginAllowedTo"
                  :timeOnly="true"
                  :hourFormat="'24'"
                  :showIcon="true"
                  :stepMinute="5"
                  placeholder="Select End Time"
                />
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <Button type="submit" class="p-button-raised" @click.prevent="addOrganisaction"
            label="Update"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <Button type="submit" @click.prevent="addCancel" class="p-button-raised p-button-danger"
            label="Cancel"/>
          </div>
        </div>
        </form>
      </Dialogs>

  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import InputMask from 'primevue/inputmask'
import Dialogs from 'primevue/dialog'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Carousel from 'primevue/carousel'
import Dialog from '../layout/dialog'
import Textarea from 'primevue/textarea'
import Calendar from 'primevue/calendar/Calendar'
import Checkbox from 'primevue/checkbox'
export default {
  name: 'customer',
  props: {
    value: {
      required: true
    }
  },
  data() {
    return {
      name: '',
      contactNumber: '',
      dialogShow: false,
      openImageViewer: false,
      showItemUploadDialog: false,
      loginAllowedFrom: null,
      loginAllowedTo: null,
      username: '',
      nameOfuser: '',
      address: '',
      shortName: '',
      contactPerson: '',
      telcontact: '',
      secondaryContact: '',
      password: '123456',
      printBillRealTime: false,
      email: '',
      panNo: '',
      taxType: '',
      website: '',
      orgRemarks: '',
      isEnglishDate: '',
      images: [],
      imageList: [],
      deletedImage: [],
      url: [],
      date_list: [
        {'isEnglishDate': 'Nepali'},
        {'isEnglishDate': 'English'}
      ],
      organisaction_type: [
        {'taxType': 'Vat'},
        {'taxType': 'Pan'}
      ],
      id: ''
    }
  },
  computed: {
  },
  mounted() {
    this.editOrganization()
  },
  methods: {
    async addOrganisaction() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter name!', life: 10000})
        return
      }
      // let user = {
      //   username: this.username,
      //   name: this.nameOfuser,
      //   password: this.password
      // }
      if (this.isEnglishDate === 'English') {
        this.isEnglishDate = true
      } else {
        this.isEnglishDate = false
      }
      let user = {
        username: '',
        name: '',
        password: ''
      }
      let org = {
        name: this.name,
        shortName: this.shortName,
        contactNumber: this.contactNumber,
        telPhone: this.telcontact,
        address: this.address,
        email: this.email,
        contactPerson: this.contactPerson,
        taxType: this.taxType,
        username: this.username,
        nameOfuser: this.nameOfuser,
        id: this.id,
        panNumber: this.panNo,
        englishDateTransaction: this.isEnglishDate,
        loginAllowedFrom: this.cleanTimeFormat(this.loginAllowedFrom),
        loginAllowedTo: this.cleanTimeFormat(this.loginAllowedTo),
        userDTO: user,
        webSite: this.website,
        orgRemarks: this.orgRemarks,
        printBillRealTime: this.printBillRealTime
      }
      const formData = new FormData()
      formData.append('organisation', JSON.stringify(org))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      // debugger
      let resp = ''
      this.loading = !this.loading
      resp = await this.$store.dispatch('updateOrganization', formData)
      this.loading = false
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 5000})
        this.editOrganization()
        this.addCancel()
        // this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 5000})
        // this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    cleanTimeFormat(time) {
      if (!time) return null
      if (time instanceof Date) {
        const hours = String(time.getHours()).padStart(2, '0')
        const minutes = String(time.getMinutes()).padStart(2, '0')
        return `${hours}:${minutes}`
      }
      if (typeof time === 'string' && time.includes(':')) {
        const parts = time.split(':')
        if (parts.length >= 2) {
          return `${parts[0]}:${parts[1]}`
        }
      }
      return time
    },
    async editOrganization() {
      let response = await this.$store.dispatch('loadOrganisation')
      let resp = response.data.data
      this.id = resp.id
      this.name = resp.name
      this.shortName = resp.shortName
      this.address = resp.address
      this.telcontact = resp.telPhone
      this.contactNumber = resp.contactNumber
      this.email = resp.email
      this.loginAllowedFrom = resp.loginAllowedFrom
      this.loginAllowedTo = resp.loginAllowedTo
      this.contactPerson = resp.contactPerson
      this.panNo = resp.panNumber
      if (resp.englishDateTransaction === true) {
        this.isEnglishDate = 'English'
      } else {
        this.isEnglishDate = 'Nepali'
      }
      this.taxType = resp.taxType
      this.website = resp.webSite
      this.orgRemarks = resp.orgRemarks
      this.printBillRealTime = resp.printBillRealTime
      if (resp.imageList.length > 0) {
        this.imageList = resp.imageList
        // this.url = data.imageList
      }
      // debugger
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    back() {
      this.openImageViewer = false
    },
    removeImage(data, props) {
      if (data.id !== undefined && data !== null) {
        this.deletedImage.push(data.id)
      }
      this.url.splice(props.index, 1)
      this.imageList.splice(props.index, 1)
    },
    viewImage() {
      this.openImageViewer = true
    },
    addCancel() {
      this.$emit('cancel')
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    closeImageUpload() {
      this.showItemUploadDialog = false
    },
    cancelImageUpload() {
      this.showItemUploadDialog = false
      this.url = []
      this.images = []
    },
    // reset() {
    //   this.name = ''
    //   this.email = ''
    //   this.address = ''
    //   this.contactNumber = ''
    //   this.contactPerson = ''
    //   this.shortName = ''
    //   this.telcontact = ''
    //   this.secondaryContact = ''
    //   this.contactPerson = ''
    //   this.panNo = ''
    //   this.taxType = ''
    //   this.username = ''
    //   this.nameOfuser = ''
    //   this.website = ''
    //   this.isEnglishDate = ''
    // },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  },
  components: {
    Dropdown,
    Calendar,
    InputMask,
    Dialogs,
    RadioButton,
    Button,
    InputText,
    Carousel,
    Dialog,
    Textarea,
    Checkbox
  }
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// UpdateOrganisation.vue?ac4eda10